import createTypography from "./createTypography";
export var typography = createTypography({
  htmlFontSize: 10 // px

});
export var zIndex = {
  drawer: 1200,
  modal: 1300
};
export var fontFamily = '"Open Sans", Arial, "Helvetica Neue", Helvetica, sans-serif';
export var white = "#ffffff";
export var black = "#000000";
export var primaryColor = "#ee2e24";
export var greyEnterpriseprimary = "#2c3e50";
export var greyEnterprise1 = "#9fa7af";
export var greyEnterprise2 = "#78848f";
export var greyEnterprise3 = "#536270";
export var greyEnterprise4 = "#253342";
export var greyEnterprise5 = "#1d2833";
export var greyEnterprise6 = "#141d25";
export var redPrimary = "#ee2e24";
export var red1 = "#f7a09b";
export var red2 = "#f47a73";
export var red3 = "#f1544b";
export var red4 = "#c3261e";
export var red5 = "#981e17";
export var red6 = "#6d1511";
export var red7 = "#ea2027";
export var blue1 = "#083856";
export var blue2 = "#186FAA";
export var blue3 = "#329BE2";
export var blue4 = "#2ba7bc";
export var blue5 = "#52c3e4";
export var greenPrimary = "#4dbb81";
export var green1 = "#aee0c5";
export var green2 = "#8dd3ae";
export var green3 = "#6dc797";
export var green4 = "#409a6a";
export var green5 = "#327753";
export var green6 = "#23553b";
export var greenButton = "#5cb85c";
export var green7 = "#00a34f";
export var green8 = "#85c440";
export var green9 = "#006400";
export var greyAdobe1 = "#cbcbcb";
export var greyAdobe2 = "#bebebe";
export var greyAdobe3 = "#b2b1b0";
export var greyAdobe4 = "#a4a3a2";
export var greyAdobe5 = "#8e8e8d";
export var greyAdobe6 = "#7d7c7c";
export var greyAdobe7 = "#676665";
export var greyAdobe8 = "#959595";
export var greyAdobe9 = "#7f7f7f";
export var greyAdobe10 = "#626363";
export var greyAdobe11 = "#474647";
export var greyAdobe12 = "#3d3d3d";
export var greyAdobe13 = "#343434";
export var greyAdobe14 = "#2b2a2a";
export var greyAdobe15 = "#3a3a3a";
export var greyLight1 = "#f6f6f6";
export var greyLight2 = "#4a3f3f";
export var greyLight3 = "#e5e5e5";
export var greyLight4 = "#e2e6e8";
export var amber = "#f7941d";
export var yellow = "#f3c534";
export var blue = "#588bce";
export var yellow1 = "#ffc630";
export var orange1 = "#f35e1e";
export var greyBackground = "#eaeaea";
export var headerBackgroundColor = "#eaeaea";
export var sidebarBackgroundColor = "#e1e1e1";
export var linkColour = "#252525";
export var spacingUnit = 8;
export var breakpointSm = 600;
export var breakpointTablet = 768;
export var breakpointMd = 960;
export var breakpointLg = 1024;
export var breakpointXl = 1300;
export var breakpointXXl = 1440;
export var breakpointXXXl = 1600;
export var breakpointXXXXl = 1920;
export var mobBreakpoint1 = 360;
export var mobBreakpoint2 = 375;
export var mobBreakpoint3 = 425;
export var fontWeightNormal = 400;
export var fontWeightBold = 600;
export var fsMini = "1rem";
export var fsSmall = "1.2rem";
export var fsBase = "1.4rem";
export var fsH3 = "1.6rem";
export var fsH2 = "2rem";
export var fsH1 = "2.4rem";
export var fsBig = "3.2rem";
export var fsHuge = "4rem";
export var appbarHeight = 48;
export var searchbarHeight = appbarHeight - 10;
export var drawerWidth = "225px";
export var mobileSearchBarHeight = 50;
export var desktopPagePadding = 30;
export var mobilePagePadding = 10;